import * as systemOrder from "./systemOrder";
import * as systemOrderItem from "./systemOrderItem";
import * as systemOrderPackage from "./systemOrderPackage";
import * as systemOrderPackageDeliveryInformation from "./systemOrderPackageDeliveryInformation";

export const oms = {
  systemOrder,
  systemOrderItem,
  systemOrderPackage,
  systemOrderPackageDeliveryInformation,
};
